/**
 * Registers any new custom formats
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Kelvin Nguyen
 */
import { Quill } from 'react-quill'
import Link from './link'

Quill.register('formats/link', Link)
